<template>
    <div class="">
        <header class="card-header filter-header" @click="expandCardBody">
            <div class="button is-theme">
                Advanced Search
                <div class="advance-search-icon"><i class="fas fa-search"></i></div>
            </div>
            <a class="card-header-icon" aria-label="more options">
                <span class="icon" v-if="!expanded">
                   <i class="fas fa-angle-down" aria-hidden="true"></i>
                </span>
                <span class="icon" v-if="expanded">
                   <i class="fas fa-angle-up" aria-hidden="true"></i>
                </span>
            </a>
        </header>
        <div class="card-content" v-if="expanded">
            <div class="content">
                <div class="columns" v-if="!isMobile">
                    <div class="column is-narrow">
                        <displacement-range-slider-stock></displacement-range-slider-stock>
                    </div>
                </div>
                <div class="columns" v-if="!isMobile">
                    <div class="column is-narrow">
                        <transmissions-specification-stock></transmissions-specification-stock>
                    </div>
                </div>
                <div class="columns">
                    <div class="column is-narrow">
                        <specification-color-palette-stock></specification-color-palette-stock>
                    </div>
                </div>
                <div class="columns">
                    <div class="column is-narrow">
                        <auction-grades-stock></auction-grades-stock>
                    </div>
                </div>
                <div class="columns" v-for="(region, index) in getRegions">
                    <div class="column">
                        <auctions-stock :region="region" :counter="index" :key="index"></auctions-stock>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DisplacementRangeSliderStock from "./DisplacementRangeSliderStock";
    import TransmissionsSpecificationStock from "./TransmissionsSpecificationStock";
    import SpecificationColorPaletteStock from "./SpecificationColorPaletteStock";
    import AuctionGradesStock from "./AuctionGradesStock";
    import AuctionsStock from "./AuctionsStock";
    export default {
        components: {
            AuctionsStock,
            DisplacementRangeSliderStock,
            TransmissionsSpecificationStock,
            SpecificationColorPaletteStock,
            AuctionGradesStock,
        },
        data() {
            return {
                expanded: false
            }
        },
        computed: {
            getRegions() {
                return this.$store.getters.getRegionsStock
            },
            isMobile() {
                return document.documentElement.clientWidth < 450;
            }
        },
        methods: {
            expandCardBody() {
                this.expanded = !this.expanded
            }
        },
        mounted() {
            this.$store.dispatch('fetchAuctionsDataStock')
        },
    }
</script>

<style>
    .content ul {
        list-style: none !important;
        margin-left: 0 !important;
        margin-top: 0 !important;
    }
    .card-header:hover {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/StockCars/SpecificFilterStockCar.vue